export const state = () => ({
  selectSecretary: {},
  Result:'',
  editSecretary:{},
})